import axios from "axios";

const API = "http://localhost:3040"; // Ajustar conforme necessário

export const buscarDashboardResumo = async (idRede) => {
  const response = await axios.get(`${API}/dashboard/fluxo-mensal?id_rede=${idRede}`);
  return response.data;
};

export const buscarComparativoReceitaDespesa = async (idRede) => {
  const response = await axios.get(`${API}/dashboard/comparativo-receita-despesa?id_rede=${idRede}`);
  return response.data;
};

export const listarContasPagar = async (idRede, filtros = {}) => {
  const response = await axios.get(`${API}/contas/pagar`, { params: { id_rede: idRede, ...filtros } });
  return response.data;
};

export const listarContasReceber = async (idRede, filtros = {}) => {
  const response = await axios.get(`${API}/contas/receber`, { params: { id_rede: idRede, ...filtros } });
  return response.data;
};

export const listarFornecedores = async (idRede) => {
  const response = await axios.get(`${API}/fornecedores?id_rede=${idRede}`);
  return response.data;
};

export const gerarRelatorioPDF = async (idRede, filtros = {}) => {
  const response = await axios.get(`${API}/relatorios/pdf`, {
    params: { id_rede: idRede, ...filtros },
    responseType: "blob",
  });
  return response.data;
};

export const gerarRelatorioCSV = async (idRede, filtros = {}) => {
  const response = await axios.get(`${API}/relatorios/csv`, {
    params: { id_rede: idRede, ...filtros },
    responseType: "blob",
  });
  return response.data;
};

export const buscarRelatorioPeriodo = async (idRede, inicio, fim) => {
  const response = await axios.get(`${API}/relatorios/periodo`, {
    params: { inicio, fim },
    headers: {
      'x-id-rede': idRede
    }
  });
  return response.data;
};
